var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1","xmlns":"http://www.w3.org/2000/svg","title":"Vacío","aria-label":"Vacío"}},[_c('path',{attrs:{"fill-rule":"evenodd","d":"","fill":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }